// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 653 ? "locale-[request]" : chunkId) + "-legacy." + {"379":"5c6e5f34","427":"f8a52e81","569":"7195cceb","653":"2e25ec05","657":"e1101252","686":"90ab22af","777":"b6b2c06e","806":"c03f3a3d","993":"5c4f8951","998":"1d80b867"}[chunkId] + ".js";
};